import React from 'react'
import { useAppSelector } from 'src/app/hooks'
import { AdminTransfer } from 'src/core/models'
import { currencyListSelector } from 'src/features'
import { FormLabels, CustomText } from 'src/components'
import styles from './TransferListColumnMovileView.module.scss'
import TransferDetailsButton from '../TransferListActionsColumn/TransferDetailsButton/TransferDetailsButton'
import TransferValidateButton from '../TransferListActionsColumn/TransferValidateButton/TransferValidateButton'
import { getFormatedPrice, getTransferCompanyName, getTransferUser, getTransformedDateTime } from 'src/core/helpers'

const TransferListColumnMovileView: React.FC<{ transfer: AdminTransfer }> = ({ transfer }) => {
  // Main Label
  const nameLabel = `${getTransferUser(transfer)} (${getTransferCompanyName(transfer)})`

  // Price
  const currencyList = useAppSelector(currencyListSelector)
  const currencyCode = currencyList.find(c => c.id === transfer.order.currency_token)?.code || 'EUR'
  const priceLabel = `${getFormatedPrice(transfer.order.total, currencyCode)} - ${currencyCode}`

  // Date Label
  const dateLabel = getTransformedDateTime(transfer.order.created)

  return <>
    <FormLabels
      title={nameLabel}
      subtitle={priceLabel}
      thirdLabel={dateLabel}
    />
    <CustomText
      label={transfer.order.reference}
      className={styles.reference}
      type='secondary'
    />

    <div className={styles.actionsContent}>
      <TransferDetailsButton transfer={transfer} />
      <TransferValidateButton transfer={transfer} />
    </div>
  </>
}

export default TransferListColumnMovileView
